import { useQueryClient, useMutation } from "@tanstack/react-query";
import {
  unArchiveRecipe,
} from "../api";
import { errorMessage, successMessage } from "../../../utils/helper";
import { useArchivedRecipeKeys } from "./useArchivedRecipeKeys";
import { useRecipeKeys } from "./useRecipeKeys";

export const useUnArchiveRecipeQueries = () =>
{

  const {recipeKeys} = useRecipeKeys();
  
  const {archiveRecipeKeys} = useArchivedRecipeKeys();
 const queryClient = useQueryClient();
    //create category
  const mutateUnArchiveRecipe = useMutation({
    mutationFn: unArchiveRecipe,
    onError: (error) => {
      errorMessage(error.response.data.message);
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: archiveRecipeKeys.list(),
      });
      successMessage("Recipe Unarchived successfully");
      variables.handleClose();
    },
  });
  return {mutateUnArchiveRecipe};
}